import _extends from "@babel/runtime/helpers/extends";
import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { formatPrettyDate, fetchEventContentById, beautyTime } from '../utils';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import ReactDOM from 'react-dom/client';
import facebook from '../../../images/fb.png';
import instagram from '../../../images/instagram.png';
import twitter from '../../../images/twitter.png';
import tiktok from '../../../images/tiktok.png';
import iconTalk from '../../../images/map/talk.svg';
import iconExhibit from '../../../images/map/exhibition.svg';
import iconPanel from '../../../images/map/panel.svg';
import iconRetail from '../../../images/map/retail.svg';
import websiteIcon from '../../../images/event-website.png';
import Slider from "react-slick";
import { AddToCalendarButton } from 'add-to-calendar-button-react';
var socialIcons = {
  facebook: facebook,
  instagram: instagram,
  tiktok: tiktok,
  twitter: twitter
};
var accessToken = 'pk.eyJ1IjoiYnBia255IiwiYSI6ImNqbHBzaTZubjI4azcza3M2czJzem56cDIifQ.aMEPR8dk5e3Jkn52QzesUw';
mapboxgl.accessToken = accessToken;
var EventSlideout = function EventSlideout(props) {
  var navigate = useNavigate();
  var params = useParams();
  var curEventType = params.type;
  var currentPath = params.type === 'virtual' ? params.cat : params.event;
  var supportingUrl = params.type === 'virtual' ? params.cat === 'instagram' ? null : params.event : params.supporting || null;
  if (params.cat === 'instagram') {
    currentPath = params.event || '';
  }
  var mapContainer = useRef(null);
  var map = useRef(null);
  var slideoutRef = useRef(null);
  var slideoutClose = useRef();
  var selectedTestDay = useSelector(function (state) {
    return state.selectedTestDay;
  });
  var _useState = useState(new Date()),
    _useState2 = _slicedToArray(_useState, 2),
    today = _useState2[0],
    setToday = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    eventContent = _useState4[0],
    setEventContent = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    scrollPos = _useState6[0],
    setScrollPos = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    eventCalendarTitle = _useState8[0],
    setEventCalendarTitle = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    loading = _useState10[0],
    setLoading = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    closing = _useState12[0],
    setClosing = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showInstructions = _useState14[0],
    setShowInstructions = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    mapMarkers = _useState16[0],
    setMapMarkers = _useState16[1];
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    locationURL = _useState18[0],
    setLocationURL = _useState18[1];
  var _useState19 = useState(-73.9791500),
    _useState20 = _slicedToArray(_useState19, 2),
    lng = _useState20[0],
    setLng = _useState20[1];
  var _useState21 = useState(40.7590403),
    _useState22 = _slicedToArray(_useState21, 2),
    lat = _useState22[0],
    setLat = _useState22[1];
  var _useState23 = useState(12),
    _useState24 = _slicedToArray(_useState23, 2),
    zoom = _useState24[0],
    setZoom = _useState24[1];
  var _useState25 = useState([]),
    _useState26 = _slicedToArray(_useState25, 2),
    bounds = _useState26[0],
    setBounds = _useState26[1];
  var intro = params.intro ? params.intro : false;
  useEffect(function () {
    if (currentPath !== '') {
      getEventContent(true, intro);
    }
    setToday(selectedTestDay ? new Date(selectedTestDay + " ".concat(today.getHours(), ":").concat(today.getMinutes(), ":").concat(today.getSeconds())) : new Date());
  }, []);
  useEffect(function () {
    if (map.current) {
      populateMarker();
    } else {
      if (!mapContainer.current || !eventContent.location_address) return;
      map.current = new mapboxgl.Map({
        container: mapContainer.current,
        style: 'mapbox://styles/bpbkny/cjlpmcnpa7t812speb0hkee3q',
        center: [lng, lat],
        zoom: zoom
      });
      map.current.scrollZoom.disable();
      populateMarker();
    }
    var directionsUrl = null;
    if (eventContent && 'location_address' in eventContent && eventContent.location_address !== "") {
      var address = eventContent.location_address.address.replace(/\,/g, '');
      var addressUrl = address.replace(/\ /g, '%20');
      directionsUrl = "https://www.google.com/maps/dir//".concat(addressUrl);
    }
    setLocationURL(directionsUrl);
    window.onpopstate = function (e) {
      closeSlideout(e);
    };
    if (eventContent) {
      var eventTitle = eventContent.title || '';
      if (eventContent.subtitle) {
        eventTitle = eventContent.title ? "".concat(eventContent.title, " / ").concat(eventContent.subtitle) : eventContent.subtitle;
      }
      setEventCalendarTitle(eventTitle);
    }
  }, [eventContent]);
  var populateMarker = function populateMarker() {
    if (!eventContent || !('location_address' in eventContent) || eventContent.location_address === "") return;
    var ref = /*#__PURE__*/React.createRef();
    // Create a new DOM node and save it to the React ref
    ref.current = document.createElement("div");
    var markerRoot = ReactDOM.createRoot(ref.current);
    var icon = iconPanel;
    if (eventContent.event_types) {
      switch (eventContent.event_types[0].slug) {
        case 'exhibition':
        case 'reception':
          icon = iconExhibit;
          break;
        case 'panel':
        case 'workshop':
          icon = iconPanel;
          break;
        case 'artist-talk':
        case 'talk':
          icon = iconTalk;
          break;
        case 'retail-event':
          icon = iconRetail;
          break;
        default:
          icon = iconExhibit;
          break;
      }
    }
    markerRoot.render( /*#__PURE__*/React.createElement("div", {
      className: "map-event-marker"
    }, /*#__PURE__*/React.createElement("img", {
      src: icon
    })));
    // Render a Marker Component on our new DOM node
    var coordinates = new mapboxgl.LngLat(eventContent.location_address.lng, eventContent.location_address.lat);
    // Create a Mapbox Marker at our new DOM node
    new mapboxgl.Marker(ref.current).setLngLat(coordinates).addTo(map.current);
    var bounds = [{
      lat: coordinates.lat - .0008,
      lng: coordinates.lng - .0008
    }, {
      lat: coordinates.lat + .0008,
      lng: coordinates.lng + .0008
    }];
    map.current.fitBounds(bounds, {
      padding: 80
    });
  };
  var toggleShowInstructions = function toggleShowInstructions() {
    setShowInstructions(!showInstructions);
  };
  var getEventContent = function getEventContent(update, intro) {
    setLoading(true);
    setScrollPos(window.scrollY);
    document.body.classList.add('modal-open');
    fetchEventContentById(currentPath, intro, supportingUrl).then(function (content) {
      if (content) {
        var timeout = window.screen.width < 768 ? 0 : 250;
        setTimeout(function () {
          setEventContent(content);
          setLoading(false);
        }, timeout);
      } else {
        document.body.classList.remove('modal-open');
        setLoading(false);
        setScrollPos(window.scrollY);
      }
    });
  };
  var closeSlideout = function closeSlideout(event) {
    if (event.type === 'popstate' || slideoutRef && !slideoutRef.current.contains(event.target) || slideoutClose.current.contains(event.target)) {
      event.preventDefault();
      var timeout = window.screen.width < 768 ? 0 : 300;
      document.body.classList.remove('modal-open');
      setClosing(true);
      var closePath = curEventType === 'virtual' ? params.cat === 'instagram' ? "/".concat(curEventType, "/instagram") : "/".concat(curEventType) : "/".concat(curEventType, "/").concat(params.cat);
      setTimeout(function () {
        setClosing(false);
        setEventContent(null);
        navigate(closePath);
        window.scrollTo(0, scrollPos);
      }, timeout);
    }
    return;
  };
  var borderColor = '#FEF200';
  if (eventContent) {
    if (eventContent.event_themes && eventContent.event_themes.length > 0) {
      borderColor = eventContent.event_themes[0].color ? eventContent.event_themes[0].color : '#FEF200';
    }
  }
  useEffect(function () {
    if (selectedTestDay !== null) {
      setToday(new Date(selectedTestDay + " ".concat(today.getHours(), ":").concat(today.getMinutes(), ":").concat(today.getSeconds())));
    }
  }, [selectedTestDay]);
  var settings = {
    dots: false,
    infinite: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  var eventStatus = 'future';
  var rsvpLink = null;
  var rsvpLabel = '';
  if (eventContent) {
    var eventStartDate = new Date(eventContent.event_date + 'T09:00:00');
    var weekStartDate = new Date('2022-11-14T07:00:00');
    var eventEndTime = eventContent.end_time;
    var eventEndDate = new Date(eventContent.event_date + 'T' + eventEndTime);
    rsvpLink = null;
    rsvpLabel = null;
    if (params.type === 'one-time') {
      eventStartDate = eventContent.event_date && eventContent.event_date !== '' ? eventContent.event_date : eventContent.start_date ? eventContent.start_date : eventContent.dates[0].event_date;
      //   console.log(typeof eventContent.start_time)
      var eventStartTime = eventContent.start_time ? _typeof(eventContent.start_time) === 'object' ? eventContent.start_time.reduce(function (acc, loc) {
        return acc.split(':')[0] < loc.split(':')[0] ? acc : loc;
      }) : eventContent.start_time ? eventContent.start_time : '06:00:00' : '06:00:00';
      // if ( typeof eventContent.start_time === 'object' ) {
      //   eventStartTime = 
      // }
      eventStartDate = new Date(eventStartDate + 'T' + eventStartTime);
      if (today >= eventStartDate) {
        rsvpLabel = eventContent.link ? eventContent.link.title === '' ? 'View Now' : eventContent.link.title : null;
        rsvpLink = eventContent.link ? eventContent.link.url : null;
      } else {
        rsvpLink = eventContent.rsvp ? eventContent.rsvp.url : null;
        rsvpLabel = eventContent.rsvp && eventContent.rsvp.title ? eventContent.rsvp.title : 'RSVP';
      }
    }
    if (params.type === 'on-going' || params.type === 'virtual') {
      if (eventContent.start_date) {
        var _eventStartTime = eventContent.start_time ? eventContent.start_time : '06:00:00';
        eventStartDate = new Date(eventContent.start_date + 'T' + _eventStartTime);
        var _eventEndTime = eventContent.end_time ? eventContent.end_time : '11:59:00';
        eventEndDate = eventContent.end_date ? new Date(eventContent.end_date + 'T' + _eventEndTime) : new Date(eventContent.start_date + 'T' + _eventEndTime);
      }
      if (eventContent.dates && eventContent.dates.length) {
        var _eventStartTime2 = eventContent.dates[0].start_time ? eventContent.dates[0].start_time : '06:00:00';
        eventStartDate = new Date(eventContent.dates[0].event_date + 'T' + _eventStartTime2);
        var _eventEndTime2 = eventContent.dates[eventContent.dates.length - 1].end_time ? eventContent.dates[eventContent.dates.length - 1].end_time : '11:59:00';
        eventEndDate = new Date(eventContent.dates[eventContent.dates.length - 1].event_date + 'T' + _eventEndTime2);
      }
      if (eventContent.date && _typeof(eventContent.date) !== 'object') {
        var _eventStartTime3 = eventContent.start_time ? eventContent.start_time : '06:00:00';
        eventStartDate = _typeof(eventContent.date) === 'object' ? new Date(eventContent.date[0] + 'T' + _eventStartTime3) : new Date(eventContent.date + 'T' + _eventStartTime3);
        var _eventEndTime3 = eventContent.date.end_time ? eventContent.date.end_time : '11:59:00';
        eventEndDate = _typeof(eventContent.date) === 'object' ? new Date(eventContent.date[eventContent.date[0] - 1] + 'T' + _eventEndTime3) : new Date(eventContent.date + 'T' + _eventEndTime3);
        // console.log(eventContent.title, eventContent, 'start date: ', eventStartTime, 'start time: ', eventContent.start_time)
      }
      if (curEventType === 'on-going') {
        if (today >= eventStartDate) {
          rsvpLabel = eventContent.event_url ? 'View Now' : null;
          rsvpLink = eventContent.event_url ? eventContent.event_url : null;
        } else {
          rsvpLabel = eventContent.rsvp && eventContent.rsvp.title ? eventContent.rsvp.title : 'Get Notified';
          rsvpLink = eventContent.rsvp ? eventContent.rsvp.url : 'https://nycjewelryweek.com/join-us/';
        }
      }

      //   console.log(today, eventStartDate)
      if (curEventType === 'virtual') {
        if (today >= eventStartDate || Object.prototype.toString.call(eventStartDate) === '[object Date]') {
          rsvpLabel = null;
          rsvpLink = null;
          if (nycjwEventSettings.watch_live_link) {
            rsvpLabel = nycjwEventSettings.watch_live_link.title ? nycjwEventSettings.watch_live_link.title : 'Watch Now';
            rsvpLink = nycjwEventSettings.watch_live_link.url;
          }
          if (eventContent.link) {
            rsvpLabel = eventContent.link.title ? eventContent.link.title : 'Watch Now';
            rsvpLink = eventContent.link.url;
          }
          if (eventContent.instagram) {
            rsvpLabel = nycjwEventSettings.watch_live_link.title ? nycjwEventSettings.watch_live_link.title : 'Watch On Instagram';
            rsvpLink = 'https://instagram.com/nycjewelryweek';
          }
        } else {
          rsvpLabel = eventContent.rsvp && eventContent.rsvp.title ? eventContent.rsvp.title : 'Get Notified';
          rsvpLink = eventContent.rsvp ? eventContent.rsvp.url : 'https://nycjewelryweek.com/join-us/';
        }
      }
    }
  }
  //   console.log(eventContent)
  //   if (eventContent.start_date ) {
  // console.log('DATE', eventContent.start_date)
  //   }

  if (eventContent) {
    console.log('event content', eventContent);
  }
  var getDatesBetween = function getDatesBetween(startDate, endDate) {
    // Convert the start and end dates to Date objects
    var start = new Date(startDate);
    var end = new Date(endDate);

    // Array to hold the dates
    var dates = [];

    // Iterate over each day between the start and end dates
    while (start <= end) {
      // Push the current date to the array
      dates.push(new Date(start));
      // Move to the next day
      start.setDate(start.getDate() + 1);
    }
    return dates;
  };

  // const eventCalendarTitle = useMemo(() => {
  //   if ( !eventContent ) return ''

  //   let eventTitle = eventContent.title || ''
  //   if ( eventContent.subtitle ) {
  //     eventTitle = eventContent.title 
  //       ? `${eventContent.title} / ${eventContent.subtitle}`
  //       : eventContent.subtitle
  //   }
  //   return eventTitle
  // }, [eventContent])

  return /*#__PURE__*/React.createElement("div", {
    id: "event-slideout",
    className: "".concat(loading ? 'loading' : '').concat(eventContent ? 'loaded' : '').concat(closing ? ' closing' : ''),
    onClick: closeSlideout
  }, /*#__PURE__*/React.createElement("div", {
    id: "event-slideout-wrapper",
    style: {
      borderColor: borderColor
    },
    ref: slideoutRef
  }, eventContent && /*#__PURE__*/React.createElement("div", {
    ref: slideoutClose,
    style: {
      borderColor: borderColor
    },
    onClick: closeSlideout,
    id: "close-slide"
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", null, "Events"))), eventContent && /*#__PURE__*/React.createElement("div", {
    id: "event-slideout-content-wrapper",
    style: {
      paddingTop: 60
    }
  }, /*#__PURE__*/React.createElement("div", {
    id: "event-slideout-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-slideout-header"
  }, (eventContent.event_types || eventContent.event_themes) && /*#__PURE__*/React.createElement("div", {
    className: "top-wrapper"
  }, /*#__PURE__*/React.createElement("p", {
    className: "event-type"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      background: 'black',
      color: 'white'
    }
  }, eventContent.virtual_event === 'irl' ? 'In-person' : 'virtual'), eventContent.event_types && /*#__PURE__*/React.createElement("span", {
    style: {
      background: '#fef200',
      color: 'black'
    }
  }, eventContent.event_types && eventContent.event_types.length > 0 ? eventContent.event_types[0].name : '')), rsvpLink && /*#__PURE__*/React.createElement(React.Fragment, null, rsvpLink === 'mailinglist' ? /*#__PURE__*/React.createElement("a", {
    style: {
      cursor: 'pointer'
    },
    className: "btn rsvp-link mailinglist",
    onClick: function onClick(e) {
      e.preventDefault();
      document.body.classList.add('signup-active');
      document.body.classList.remove('modal-open');
      navigate('/virtual');
      setEventContent(null);
      window.scrollTo(0, scrollPos);
    }
  }, rsvpLabel) : /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    className: "btn rsvp-link",
    href: rsvpLink
  }, rsvpLabel))), eventContent.title && /*#__PURE__*/React.createElement("h2", {
    dangerouslySetInnerHTML: {
      __html: eventContent.title ? eventContent.title : 'EVENT TITLE'
    }
  }), eventContent.subtitle && /*#__PURE__*/React.createElement("h3", {
    style: {
      marginTop: '.75rem'
    }
  }, eventContent.subtitle), eventContent.images && /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, /*#__PURE__*/React.createElement(Slider, _extends({
    className: "event-image-gallery"
  }, settings), eventContent.images.map(function (image) {
    return /*#__PURE__*/React.createElement("div", {
      key: image.id,
      className: "event-image-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "event-image",
      role: "img"
      // aria-label={ image.alt }
      ,
      style: {
        backgroundImage: "url(".concat(image.src, ")")
      }
    }));
  })))), (eventContent.dates && eventContent.dates.length > 0 || eventContent.start_date) && /*#__PURE__*/React.createElement("div", {
    className: "event-date",
    style: {
      marginBottom: '2rem'
    }
  }, /*#__PURE__*/React.createElement("h3", {
    className: "underlined",
    style: {
      marginBottom: '1rem'
    }
  }, eventContent.dates.length == 1 ? 'Event Date' : 'Event Dates'), eventContent.dates.length > 0 && /*#__PURE__*/React.createElement("div", null, eventContent.dates.map(function (date, ind) {
    return /*#__PURE__*/React.createElement("div", {
      key: "date-".concat(ind)
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-space-between flex-align-center",
      style: {
        flexWrap: 'wrap',
        marginTop: '.5rem'
      }
    }, /*#__PURE__*/React.createElement("p", {
      style: {
        marginBottom: 0,
        marginTop: 0
      }
    }, /*#__PURE__*/React.createElement("strong", null, formatPrettyDate(date.event_date)), date.start_time && /*#__PURE__*/React.createElement("span", {
      style: {
        marginLeft: '.75rem'
      }
    }, /*#__PURE__*/React.createElement("strong", null, beautyTime(date.start_time), date.end_time && "- ".concat(beautyTime(date.end_time))))), /*#__PURE__*/React.createElement(AddToCalendarButton, {
      iCalFileName: "nycjw-calendar-event",
      buttonStyle: "flat",
      styleLight: ".atcb-button { font-family: 'Bebas Neue', sans-serif !important; border: none; background-color: black; color: white; padding: .5rem .5rem; } .atcb-button svg { fill: white; } .atcb-button span { padding-top: .1rem; } #atcb-reference { display: none; font-size: 0;} .atcb-dropdown * { font-family: 'Nunito', sans-serif !important; }",
      name: eventCalendarTitle,
      startDate: date.event_date,
      startTime: date.start_time ? date.start_time.slice(0, -3) : null,
      endTime: date.end_time ? date.end_time.slice(0, -3) : null,
      options: ['Apple', 'Google', 'Yahoo', 'iCal'],
      timeZone: "America/New_York"
    })));
  })), eventContent.start_date && /*#__PURE__*/React.createElement("div", null, getDatesBetween(eventContent.start_date, eventContent.end_date).map(function (date, ind) {
    return /*#__PURE__*/React.createElement("div", {
      key: "date-".concat(ind),
      className: "flex justify-space-between flex-align-center",
      style: {
        marginBottom: 16
      }
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
      style: {
        marginBottom: 0,
        marginTop: 0
      }
    }, /*#__PURE__*/React.createElement("strong", null, formatPrettyDate(date))), eventContent.start_time && /*#__PURE__*/React.createElement("p", {
      style: {
        marginBottom: 0,
        marginTop: 0
      }
    }, beautyTime(eventContent.start_time), eventContent.end_time && /*#__PURE__*/React.createElement("span", null, " - ".concat(beautyTime(eventContent.end_time))))), /*#__PURE__*/React.createElement(AddToCalendarButton, {
      iCalFileName: "nycjw-calendar-event",
      buttonStyle: "flat",
      styleLight: ".atcb-button { font-family: 'Bebas Neue', sans-serif !important; border: none; background-color: black; color: white; padding: .5rem .5rem; } #atcb-reference { display: none; font-size: 0;} .atcb-button svg { fill: white; } .atcb-button span { padding-top: .1rem; } .atcb-dropdown * { font-family: 'Nunito', sans-serif !important; }",
      name: eventCalendarTitle,
      startDate: eventContent.start_date,
      options: ['Apple', 'Google', 'Yahoo', 'iCal'],
      timeZone: "America/New_York"
    }));
  }))), (eventContent.location_name || eventContent.location_address || eventContent.access_instructions) && /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: '2rem'
    }
  }, /*#__PURE__*/React.createElement("h3", {
    className: "underlined",
    style: {
      marginBottom: '1rem'
    }
  }, "Location"), eventContent.location_name && eventContent.virtual_event == 'irl' && /*#__PURE__*/React.createElement("p", {
    style: {
      marginBottom: 0
    }
  }, /*#__PURE__*/React.createElement("strong", null, eventContent.location_name)), eventContent.location_address && eventContent.virtual_event == 'irl' && /*#__PURE__*/React.createElement("p", {
    style: {
      marginTop: 0,
      marginBottom: 0
    }
  }, eventContent.location_address.address), eventContent.access_instructions && eventContent.virtual_event == 'irl' && /*#__PURE__*/React.createElement("div", {
    className: "special-instructions"
  }, /*#__PURE__*/React.createElement("sub", {
    style: {
      textTransform: 'uppercase',
      marginBottom: '1rem',
      marginTop: '1rem',
      fontWeight: '600',
      cursor: 'pointer'
    },
    className: "underlined"
  }, "Special Instructions:"), /*#__PURE__*/React.createElement("p", null, eventContent.access_instructions))), /*#__PURE__*/React.createElement("div", {
    id: "nycjw-event-map-wrapper",
    style: !eventContent.location_address || eventContent.location_address === "" ? {
      display: 'none'
    } : {}
  }, locationURL && /*#__PURE__*/React.createElement("button", {
    className: "btn small directions",
    onClick: function onClick() {
      return window.open(locationURL, '_blank');
    }
  }, "Get Directions"), /*#__PURE__*/React.createElement("div", {
    ref: mapContainer,
    id: "nycjw-event-map"
  })), eventContent.content && /*#__PURE__*/React.createElement("div", null, !eventContent.intro && /*#__PURE__*/React.createElement("h3", {
    className: "underlined",
    style: {
      marginBottom: '1rem'
    }
  }, "Description"), /*#__PURE__*/React.createElement("div", {
    className: "event-content",
    dangerouslySetInnerHTML: {
      __html: eventContent.content
    }
  }), params.type === 'virtual' && /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("i", null, "Click ", /*#__PURE__*/React.createElement("b", null, "GET NOTIFIED"), " to be notified when this program is viewable.")), eventContent.social && eventContent.social.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "event-social"
  }, eventContent.project_url && /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    title: "website",
    className: "project-url bold uppercase text-button social-link",
    href: eventContent.project_url
  }, /*#__PURE__*/React.createElement("img", {
    src: websiteIcon
  })), eventContent.social.map(function (social) {
    return /*#__PURE__*/React.createElement("a", {
      key: "social-".concat(social.type),
      title: social.type,
      className: "social-link social-".concat(social.type),
      target: "_blank",
      href: social.link
    }, /*#__PURE__*/React.createElement("img", {
      src: socialIcons[social.type]
    }));
  }))), eventContent.event_types && eventContent.event_types.length && (eventContent.event_types[0].name.toLowerCase() == 'talk' || eventContent.event_types[0].name.toLowerCase() == 'performance' || eventContent.event_types[0].name.toLowerCase() == 'panel') && eventContent.virtual_event == 'virtual' && !eventContent.hide_virtual && /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: '2rem',
      marginBottom: '2rem'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      marginBottom: '.25rem',
      marginTop: 0
    }
  }, /*#__PURE__*/React.createElement("strong", null, "NYCJW22 VIRTUAL PROGRAM")), /*#__PURE__*/React.createElement("p", {
    style: {
      marginBottom: '.25rem',
      marginTop: 0
    }
  }, "Sections of this program will be released daily on YouTube and RSVP is required to access the stream. Remember to ", /*#__PURE__*/React.createElement("a", {
    style: {
      color: 'black',
      fontWeight: '600'
    },
    target: "_blank",
    href: "https://www.youtube.com/c/nycjewelryweek"
  }, "subscribe to NYC Jewelry Week\u2019s YouTube channel"), " for access to all of our content.")), eventContent.participants && eventContent.participants.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "event-participants"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "underlined"
  }, "Participants"), /*#__PURE__*/React.createElement("ul", null, eventContent.participants.map(function (participant, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: "participant-".concat(index)
    }, /*#__PURE__*/React.createElement("h5", null, participant.name), participant.bio && /*#__PURE__*/React.createElement("div", {
      className: "participant-bio",
      dangerouslySetInnerHTML: {
        __html: participant.bio
      }
    }));
  }))) : '', eventContent.sponsor && eventContent.sponsor.name.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "event-participants sponsor_layout"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "underlined"
  }, "Sponsored By"), /*#__PURE__*/React.createElement("div", {
    className: "event-sponsors"
  }, /*#__PURE__*/React.createElement("a", {
    href: eventContent.sponsor.link,
    target: "_blank"
  }, eventContent.sponsor.image && eventContent.sponsor.image.length > 0 ? /*#__PURE__*/React.createElement("img", {
    src: eventContent.sponsor.image,
    className: "sponsor_logo"
  }) : '', /*#__PURE__*/React.createElement("span", null, eventContent.sponsor.name)), eventContent.sponsors && eventContent.sponsors.map(function (sponsor) {
    return /*#__PURE__*/React.createElement("a", {
      href: sponsor.link,
      target: "_blank"
    }, sponsor.image && sponsor.image.length > 0 ? /*#__PURE__*/React.createElement("img", {
      src: sponsor.image,
      className: "sponsor_logo"
    }) : '', /*#__PURE__*/React.createElement("span", null, sponsor.name));
  }))) : '', eventContent.is_discover && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
    className: "underlined"
  }, "DISCOVER"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Find Jewelry from this event at ", /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    style: {
      color: 'black'
    },
    href: "".concat(homeurl, "/discover")
  }, "DISCOVER")))), eventContent.virtual_event === 'In-person' && eventContent.covid_messaging && /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: '4rem'
    }
  }, eventContent.covid_messaging.heading && /*#__PURE__*/React.createElement("h4", {
    className: "underlined"
  }, eventContent.covid_messaging.heading), eventContent.covid_messaging.content && /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: eventContent.covid_messaging.content
    }
  })), eventContent.supportEvents && eventContent.supportEvents.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "event-participants"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "underlined"
  }, "Supporting Events"), /*#__PURE__*/React.createElement("ul", null, eventContent.supportEvents.map(function (supportEvent, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: "support-event-".concat(index)
    }, supportEvent.event_types && /*#__PURE__*/React.createElement("p", {
      className: "event-type"
    }, supportEvent.event_types.name && /*#__PURE__*/React.createElement("span", {
      style: {
        background: 'black',
        color: 'white'
      }
    }, supportEvent.event_types.name === 'irl' ? 'In-person' : supportEvent.event_types.name)), supportEvent.event && supportEvent.event.length > 0 ? /*#__PURE__*/React.createElement("h5", {
      dangerouslySetInnerHTML: {
        __html: supportEvent.event
      }
    }) : '', supportEvent.location && supportEvent.location.address && /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, supportEvent.location.address)), supportEvent.date && supportEvent.date.length > 1 && /*#__PURE__*/React.createElement("div", {
      className: "event-date flex justify-space-between flex-align-center"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, formatPrettyDate(supportEvent.date))), supportEvent.start_time && /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("strong", null, "".concat(beautyTime(supportEvent.start_time), " - ").concat(beautyTime(supportEvent.end_time)))))), /*#__PURE__*/React.createElement(AddToCalendarButton, {
      iCalFileName: "nycjw-calendar-event",
      buttonStyle: "flat",
      styleLight: ".atcb-button { font-family: 'Bebas Neue', sans-serif !important; border: none; background-color: black; color: white; padding: .5rem .5rem; } .atcb-button svg { fill: white; } .atcb-button span { padding-top: .1rem; } #atcb-reference { display: none; font-size: 0;} .atcb-dropdown * { font-family: 'Nunito', sans-serif !important; }",
      name: "".concat(eventContent.title, " - ").concat(supportEvent.event.replace(/<[^>]*>/g, '')),
      startDate: supportEvent.date,
      startTime: supportEvent.start_time || undefined,
      endTime: supportEvent.end_time || undefined,
      options: ['Apple', 'Google', 'Yahoo', 'iCal'],
      timeZone: "America/New_York"
    })), supportEvent.rsvp && /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      href: supportEvent.rsvp.url
    }, "More Info"));
  }))) : '', /*#__PURE__*/React.createElement("div", {
    className: "text-centered follow-nycjw"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://instagram.com/nycjewelryweek",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("img", {
    src: instagram
  }), /*#__PURE__*/React.createElement("span", null, "follow NYCJW on Instagram!"))))), loading && /*#__PURE__*/React.createElement("div", {
    className: "event-loading-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-loading"
  }, "Loading"))));
};
export default EventSlideout;